module.exports = __webpack_public_path__ + "static/media/14b-04-insolada.55f93b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14b/14b-04-insolada.jpg
// module id = 152
// module chunks = 0